import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCommodity from '../_reducers/commodity';

export const selectCommodityState =
  createFeatureSelector<fromCommodity.CommodityState>('commodities');

export const selectAllCommodities = createSelector(selectCommodityState, fromCommodity.selectAll);

export const selectCommodityEntities = createSelector(
  selectCommodityState,
  fromCommodity.selectEntities
);

export const selectCommodityById = (id: number) =>
  createSelector(selectCommodityEntities, (entities) => entities[id]);

export const selectCommodityTotal = createSelector(selectCommodityState, fromCommodity.selectTotal);
